export default function toggleFilterIndicator({ state }) {
  const fileTypes = state.get('media.filter.fileTypes')

  Object.keys(fileTypes).every(id => {
    const fileType = state.get(`media.filter.fileTypes.${id}`)

    if (!fileType.selected) {
      state.set(`media.filter.active`, true)
      return false
    }
    state.set(`media.filter.active`, false)
    return true
  })
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/toggleFilterIndicator.js